import { Layout } from "@dgs/core";
import { FC } from "react";
import { Outlet } from "react-router";
import { Footer } from "./Footer";
import { PublicApplicationBar } from "./PublicApplicationBar";

export const PublicContent: FC = () => {
	return <Layout navigation={null} header={<PublicApplicationBar />} content={<Outlet />} footer={<Footer />} />;
};
